/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingpricelevel2Inputs */

const en_listingpricelevel2 = /** @type {(inputs: Listingpricelevel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price level`)
};

const de_listingpricelevel2 = /** @type {(inputs: Listingpricelevel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisniveau`)
};

/**
* | output |
* | --- |
* | "Price level" |
*
* @param {Listingpricelevel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingpricelevel2 = /** @type {((inputs?: Listingpricelevel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingpricelevel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingpricelevel2(inputs)
	return de_listingpricelevel2(inputs)
});
export { listingpricelevel2 as "listingPriceLevel" }